import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';
import { CoreModule } from 'core/core.module';
import { ReportingToolComponent } from './reporting-tool/reporting-tool.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportsService } from './reports.service';

@NgModule({
  imports: [CommonModule, CoreModule, ReportsRoutingModule],
  declarations: [ReportingToolComponent, ReportsComponent],
  exports: [],
  providers: [ReportsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportsModule {}
